import { defineComponent as _defineComponent } from 'vue'
import AiExplanationControls from '@/ui/ai-explanation/ai-explanation-controls/ai-explanation-controls.vue'
import AiExplanationOutput from '@/ui/ai-explanation/ai-explanation-output/ai-explanation-output.vue'
import { AiExplanationTextContent } from '@/ui/ai-explanation/ai-explanation.types'
import { ref } from 'vue'

interface Props {
  aiExplanationTextContent: AiExplanationTextContent
  values: Array<string>
  explain: (value: string) => Promise<string>,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-explanation',
  props: {
    aiExplanationTextContent: null,
    values: null,
    explain: null
  },
  setup(__props: any) {

const props = __props as { aiExplanationTextContent: AiExplanationTextContent, values: Array<string>, explain: (value: string) => Promise<string> }



const explanation = ref<string | null>(null)
const selected = ref<string | null>(null)
const showActions = ref<boolean>(false)

async function select (value: string): Promise<void> {
    showActions.value = false
    selected.value = value
    explanation.value = ''

    explanation.value = await props.explain(value)
}

function handleSetShowActions (show: boolean): void {
    if (explanation.value && explanation.value.length > 0) {
        showActions.value = show
    }
}

return { __sfc: true,props, explanation, selected, showActions, select, handleSetShowActions, AiExplanationControls, AiExplanationOutput }
}

})